import Body from './Body';

export default class Footer extends Body {

    constructor(options) {   
        super(options);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Footer.js